import React, { useEffect } from 'react';
import loginImage01 from "../../assets/images/registration/registration-steps-image-01.jpg";
import loginImage02 from "../../assets/images/registration/registration-steps-image-03.jpg";
import loginImage03 from "../../assets/images/registration/registration-steps-image-04.jpg";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { Endpoints } from '../../Global/Endpoints';
import { useNavigate } from "react-router-dom"; 

const ContactUs = () => {
  const { t } = useTranslation();
  const contract = useSelector((state) => state.userData);
  const phoneNumber = contract.userData?.PhoneNumber; // Fallback if PhoneNumber is unavailable
  const token = localStorage.getItem("AccessToken") || "YOUR_ACCESS_TOKEN_HERE";
  const navigate = useNavigate();


  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleSlidesOnly");

    if (myCarousel) {
      new window.bootstrap.Carousel(myCarousel, {
        interval: 5000, // Set interval in milliseconds
      });
    }

    // API Call to log Contact Us activity
    const logContactUsActivity = async () => {
      try {
        const payload = `_Params=${encodeURIComponent(
          JSON.stringify({
            EmailID: contract.userData.EmailID,
            Activity: "Contact Us",
            DeviceType: "PatientPortal",
          })
        )}`;

        const response = await axios.post(
          Endpoints.CallRecoderLog,
          payload,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          console.log(t('acticitylog'), response.data);
        } 
      } catch (error) {
        return;
      }
    };

    logContactUsActivity();
  }, [contract, token]);

  return (
    <>
      <div className="registration-block-main">
        {/* left carousel start */}
        <div className="registration-image-wrapper">
          <div
            id="carouselExampleSlidesOnly"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                <img src={loginImage01} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage02} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage03} alt="" className="registration-image" />
              </div>
            </div>
          </div>
        </div>
        {/* left carousel end */}

        {/* registration right form area start */}
        <div className="registration-form-main">
          
          <div className="registration-form ">
            <div className='form-header'>
              <button className="win-back-btn" onClick={() => {
                // Reset header menu state before navigating home
                window.dispatchEvent(new Event("resetHeaderMenu"));
                navigate("/home")
              }
              }>
                <span>
                <i className="bi bi-chevron-left"></i>
                </span>
            </button>   
            <h3 className="page-heading-secondary-black">{t('contactus')}</h3></div>
            <div className="registration-process-form-wrapper mt-5">
              <div className="mb-3">
                <h3 className="page-heading-bold">{phoneNumber}</h3>
              </div>
               <button onClick={() => navigate("/home")} className="win-btn-primary mobile-view mt-5 mb-5">{t("Back")}</button>
             
            </div>
          </div>
        </div>
        {/* registration right form area end */}
      </div>
    </>
  );
};

export default ContactUs;
